import { c as _c } from "react/compiler-runtime";
import clsx from 'clsx';
import type { JSX } from 'react';
import flags from './flags';
import { TIocCode } from './types';
export type FlagProps = {
  code: TIocCode;

  /**
   * Size of the flag. Defaults to 'small'.
   */
  size?: 'small' | 'large';

  /**
   * Text shown on hover. If omitted, the country code (in uppercase) is used.
   * Note that we are intentionally uppercasing the IOC code rather than using the ISO 3166-1-alpha-3 code, which is already uppercase, because the IOC codes are generally more familiar.
   */
  title?: string;
  'data-testid'?: string;
  className?: string;
};
const Flag = t0 => {
  const $ = _c(19);
  let className;
  let code;
  let rest;
  let t1;
  let title;
  if ($[0] !== t0) {
    ({
      code,
      title,
      size: t1,
      className,
      ...rest
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = code;
    $[3] = rest;
    $[4] = t1;
    $[5] = title;
  } else {
    className = $[1];
    code = $[2];
    rest = $[3];
    t1 = $[4];
    title = $[5];
  }
  const size = t1 === undefined ? "small" : t1;
  let t2;
  bb0: {
    if (!flags[code]) {
      t2 = undefined;
      break bb0;
    }
    const t3 = `${flags[code][size][0]}px ${flags[code][size][1]}px`;
    let t4;
    if ($[6] !== t3) {
      t4 = {
        backgroundPosition: t3
      };
      $[6] = t3;
      $[7] = t4;
    } else {
      t4 = $[7];
    }
    t2 = t4;
  }
  const style = t2;
  let t3;
  if ($[8] !== code || $[9] !== title) {
    t3 = title || code.toUpperCase();
    $[8] = code;
    $[9] = title;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  const t4 = `DsFlag-root DsFlag-${size}`;
  let t5;
  if ($[11] !== className || $[12] !== t4) {
    t5 = clsx(t4, className);
    $[11] = className;
    $[12] = t4;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  let t6;
  if ($[14] !== rest || $[15] !== style || $[16] !== t3 || $[17] !== t5) {
    t6 = <span aria-hidden={true} title={t3} style={style} {...rest} className={t5} />;
    $[14] = rest;
    $[15] = style;
    $[16] = t3;
    $[17] = t5;
    $[18] = t6;
  } else {
    t6 = $[18];
  }
  return t6;
};
export default Flag;